import {
  aCreateGithubYaraSource,
  mockCreateGithubYaraSourceOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockCreateGithubYaraSourceOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createGithubYaraSource: aCreateGithubYaraSource(),
        },
      });
    }
  ),
];
